import _objectSpread from '@babel/runtime/helpers/esm/objectSpread2';
import { createContext, useContext } from 'react';
import { ApplicationEnum } from '@landr/core.models';
import { Languages } from '../../constants/Languages.es.js';

var PricingContextDefaultValue = {
  applicationName: ApplicationEnum.Web,
  env: 'production',
  log: {},
  language: Languages.English,
  locationPathname: '',
  onSubscriptionPurchase: function onSubscriptionPurchase() {
    return undefined;
  },
  onProductPurchase: function onProductPurchase() {
    return undefined;
  },
  onSignUp: function onSignUp() {
    return undefined;
  },
  showMasteringStandardPluginOffer: false,
  showMasteringStandardALC: false,
  showLandrUltimateBundle: false,
  showLandrSynthXPlugin: false
};
var PricingContext = createContext(PricingContextDefaultValue);
var usePricingContext = function usePricingContext() {
  var context = useContext(PricingContext);
  var isPricingProviderDefined = context !== PricingContextDefaultValue;
  if (!isPricingProviderDefined) {
    throw new Error('PricingProvider not defined. Please make sure to render `PricingProvider` before using catalog hooks');
  }
  return _objectSpread(_objectSpread({}, context), {}, {
    isGuestsite: context.applicationName === ApplicationEnum.GuestSite
  });
};

export { PricingContext, PricingContextDefaultValue, usePricingContext };
